import supportedLocations from './supportedLocations'
import type { Iso3166Alpha2, Iso3166Alpha3, Iso3166Location } from './types'

let byAlpha2: Record<string, Iso3166Alpha3>
let byAlpha3: Record<string, Iso3166Alpha2>
let unlocalizedLocations: Iso3166Location[]

const ALPHA3 = { key: 0, value: 1 }
const ALPHA2 = { key: 1, value: 0 }

export function getAlpha3From2(alpha2: Iso3166Alpha2): Iso3166Alpha3 {
  byAlpha2 = byAlpha2 || reduceByKeyValue(ALPHA2)
  return byAlpha2[alpha2]
}

export function getAlpha2From3(alpha3: Iso3166Alpha3): Iso3166Alpha2 {
  byAlpha3 = byAlpha3 || reduceByKeyValue(ALPHA3)
  return byAlpha3[alpha3]
}

export function getUnlocalizedLocations(): Iso3166Location[] {
  unlocalizedLocations =
    unlocalizedLocations ||
    supportedLocations.map(([alpha3, alpha2]) => ({
      alpha3,
      alpha2,
      // use alpha3 as initial text while fetching localized text
      text: alpha3,
    }))
  return unlocalizedLocations
}

function reduceByKeyValue<Value>({ key, value }): Record<string, Value> {
  return supportedLocations.reduce((previousValue, location) => {
    previousValue[location[key]] = location[value]
    return previousValue
  }, {})
}
